import {Dropdown} from "primereact/dropdown"

const USER_TYPES = [
    {label: "RN", value: 1},
    {label: "LPN", value: 2},
]

export const OnboardingOrienteeInfo = ({orientee, onboarded, changeValues, changeUserType}) => {
    const employeeIdMissing = !orientee.employee_id?.trim()

    return (
        <div className="w-100">
            <div className="pb-5">
                <h3 className="fw-bold d-flex align-items-center text-gray-900">New Orientee Information</h3>

                <div className="text-gray-700 fw-semibold fs-6">
                    Details pre-populated by UMMS Infor Enterprise Resource Planning platform.
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="first_name">First Name</label>

                    <input
                        id="first_name"
                        type="text"
                        className="form-control form-control-solid"
                        value={orientee.first_name ?? ""}
                        readOnly
                    />
                </div>

                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="last_name">Last Name</label>

                    <input
                        id="last_name"
                        type="text"
                        className="form-control form-control-solid"
                        value={orientee.last_name ?? ""}
                        readOnly
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="employee_id">Employee ID</label>

                    <input
                        id="employee_id"
                        type="text"
                        className={`form-control ${employeeIdMissing ? "" : "form-control-solid"}`}
                        value={onboarded.employee_id}
                        readOnly={!employeeIdMissing}
                        onChange={(event) => changeValues({employee_id: event.target.value})}
                    />

                    {employeeIdMissing && (
                        <div className="form-text text-danger">Not provided by Infor, required to continue</div>
                    )}
                </div>

                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="email">Email</label>

                    <input
                        id="email"
                        type="email"
                        className="form-control form-control-solid"
                        value={orientee.email ?? ""}
                        readOnly
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="fte">FTE</label>

                    <input
                        id="fte"
                        type="text"
                        className="form-control form-control-solid"
                        value={orientee.employee_fte ?? ""}
                        readOnly
                    />
                </div>

                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required" htmlFor="position">Position</label>

                    <input
                        id="position"
                        type="text"
                        className="form-control form-control-solid"
                        value={orientee.position_name ?? ""}
                        readOnly
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 mb-8">
                    <label className="form-label required mb-2" htmlFor="user_type_id">Type</label>

                    <Dropdown
                        id="user_type_id"
                        value={onboarded.user_type_id}
                        options={USER_TYPES}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(event) => changeUserType(event)}
                        placeholder="Select Type"
                        className="w-100"
                    />
                </div>
            </div>
        </div>
    )
}
